/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

:host {
  /* Component spacing variables */
  --calcite-icon-size: 1rem;
  --calcite-spacing-eighth: 0.125rem;
  --calcite-spacing-quarter: 0.25rem;
  --calcite-spacing-half: 0.5rem;
  --calcite-spacing-three-quarters: 0.75rem;
  --calcite-spacing: 1rem;
  --calcite-spacing-plus-quarter: 1.25rem;
  --calcite-spacing-plus-half: 1.5rem;
  --calcite-spacing-double: 2rem;
  --calcite-menu-min-width: 10rem;
  --calcite-header-min-height: 3rem;
  --calcite-footer-min-height: 3rem;
}

:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-block-padding: Specifies the padding of the block `default` slot.
*/
:host {
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  flex-direction: column;
  border-width: 0px;
  border-block-end-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  padding: 0px;
  transition-property: margin;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.215, 0.440, 0.420, 0.880);
  flex-basis: auto;
  transition-duration: var(--calcite-animation-timing);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

/* helper to properly scale internal durations */
/* Shared styles for header elements */
.header {
  margin: 0px;
  display: flex;
  align-content: space-between;
  align-items: center;
  fill: var(--calcite-color-text-2);
  color: var(--calcite-color-text-2);
}

.heading {
  margin: 0px;
  padding: 0px;
  font-weight: var(--calcite-font-weight-medium);
}

.header .heading {
  flex: 1 1 auto;
  padding: 0.5rem;
}

.header {
  justify-content: flex-start;
}

.header--has-text {
  padding: var(--calcite-spacing-md);
}

.header,
.toggle {
  grid-area: header;
}

.header-container {
  display: grid;
  align-items: stretch;
  grid-template: auto/auto 1fr auto auto;
  grid-template-areas: "handle header control menu actions-end";
  grid-column: header-start/actions-end;
  grid-row: 1/2;
}

.content-start,
.icon,
.icon--start,
.icon--end {
  margin-inline-end: var(--calcite-spacing-md);
}

.icon calcite-loader {
  margin-inline-end: var(--calcite-spacing-xxxs);
}

.icon--start,
.icon--end {
  color: var(--calcite-color-text-3);
}

.actions-end {
  grid-area: actions-end;
}

.toggle {
  margin: 0px;
  display: flex;
  cursor: pointer;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  border-style: none;
  padding: 0px;
  font-family: var(--calcite-font-family);
  outline-color: transparent;
  text-align: initial;
  background-color: transparent;
}
.toggle:hover {
  background-color: var(--calcite-color-foreground-2);
}
.toggle:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

calcite-loader[inline] {
  grid-area: control;
  align-self: center;
}

calcite-handle {
  grid-area: handle;
}

.title {
  margin: 0px;
}

.header .title .heading {
  padding: 0px;
  font-size: var(--calcite-font-size--1);
  font-weight: var(--calcite-font-weight-medium);
  line-height: 1.25;
  color: var(--calcite-color-text-2);
  transition-property: color;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  word-wrap: break-word;
  word-break: break-word;
}

.description {
  margin-block-start: 0.125rem;
  padding: 0px;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  color: var(--calcite-color-text-3);
  word-wrap: break-word;
  word-break: break-word;
}

.icon {
  display: flex;
}

.status-icon.valid {
  color: var(--calcite-color-status-success);
}

.status-icon.invalid {
  color: var(--calcite-color-status-danger);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.icon-end-container {
  display: flex;
  align-items: center;
  margin-inline-start: auto;
}

.toggle-icon {
  align-self: center;
  justify-self: end;
  color: var(--calcite-color-text-3);
  transition-property: color;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  margin-inline-end: var(--calcite-spacing-md);
}

.toggle:hover .toggle-icon {
  color: var(--calcite-color-text-1);
}

.container {
  position: relative;
  display: flex;
  block-size: 100%;
  flex-direction: column;
}

.content {
  position: relative;
  min-block-size: 0px;
  flex: 1 1 0%;
}

@keyframes in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.content {
  animation: in var(--calcite-internal-animation-timing-slow) ease-in-out;
  padding-block: var(--calcite-block-padding, var(--calcite-spacing-sm));
  padding-inline: var(--calcite-block-padding, var(--calcite-spacing-md));
}

.content-start {
  display: flex;
  align-items: center;
  color: var(--calcite-color-text-3);
}

.control-container {
  margin: 0px;
  display: flex;
  grid-area: control;
}

calcite-action-menu {
  grid-area: menu;
}

.actions-end {
  display: flex;
  align-items: stretch;
}

:host([open]) {
  margin-block: 0.5rem;
}
:host([open]) .header .title .heading {
  color: var(--calcite-color-text-1);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}